export default {
  NotFound: require('./NotFound').default,
}